/**
 * Emit hosts for the `community` analytics group — 6 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@heidi/analytics/events';

export function trackCommunityTemplateImported(input: { templateId: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Community,
    props: {
      action: SegmentActionName.CommunityTemplateImported,
      templateId: input.templateId,
    },
  });
}

export function trackCommunityTemplateLiked(input: { templateId: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Community,
    props: {
      action: SegmentActionName.CommunityTemplateLiked,
      templateId: input.templateId,
    },
  });
}

export function trackCommunityTemplatePublished(input: { templateId: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Community,
    props: {
      action: SegmentActionName.CommunityTemplatePublished,
      templateId: input.templateId,
    },
  });

  // V2 — community_created
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.CommunityCreated,
    props: {
      template_id: input.templateId,
    },
  });
}

export function trackCommunityTemplateUnliked(input: { templateId: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Community,
    props: {
      action: SegmentActionName.CommunityTemplateUnliked,
      templateId: input.templateId,
    },
  });
}

export function trackCommunityTemplateViewed(input: { templateId: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Community,
    props: {
      action: SegmentActionName.CommunityTemplateViewed,
      templateId: input.templateId,
    },
  });

  // V2 — community_viewed
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.CommunityViewed,
    props: {
      template_id: input.templateId,
    },
  });
}
